export enum ComposerPanelTab {
  Architecture = 'architecture',
  Style = 'style',
  Customization = 'customization',
  Pricing = 'Pricing'
}
